import api from "./api";
import { CidadePaginate, Estado, RegionalPoloCity } from "types/Cidade";

export async function findAllCidades(
  currentPage: number,
  perPage: number,
  estado_id ?: number | null,
  sigla ?: string,
  nome ?: string,
): Promise<CidadePaginate> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/cidades`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
        estado_id,
        sigla,
        nome,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar as cidades:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar as cidades"
    );
  }
}

export async function findAllEstados(): Promise<Estado[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/estados`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar os estados:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar os estados"
    );
  }
}

export async function findAllRegionais(): Promise<RegionalPoloCity[]> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/regionais`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar as regionais:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar as regionais"
    );
  }
}
